export default "<ion-grid>\n  <ion-row class=\"ion-justify-content-center\">\n    <ion-spinner name=\"crescent\"></ion-spinner>\n  </ion-row>\n</ion-grid>\n";